export const datePickerErrorText = `The value at the start date can't be greater than the end date`;
